/* eslint-disable class-methods-use-this */
/* eslint-disable react/sort-comp */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unused-state */

'use client';

import React, { Component, ErrorInfo, ReactNode } from 'react';
import ErrorCont from '@wconcept/wconcept-ui-renewal/src/components/molecules/ErrorCont';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

const DEFAULT_ERROR_MSG = {
  type: '500',
  title: '현재 서비스 접속이 <br class="inline-pc" />원활하지 않습니다.',
  detail: '이용에 불편을 드려 죄송합니다. <br />잠시 후 다시 시도해 주세요.',
  linkText: '다시 시도하기',
  logo: true,
};

class CustomErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  public static getDerivedStateFromError(error: Error): State {
    // 다음 렌더링에서 폴백 UI가 보이도록 상태를 업데이트
    return {
      hasError: true,
      error,
      errorInfo: null,
    };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // 에러 로깅
    console.error('Error caught by boundary:', {
      error,
      errorInfo,
      timestamp: new Date().toISOString(),
      url: window?.location?.href,
    });

    this.setState({
      error,
      errorInfo,
    });

    // 여기에 에러 로깅 서비스 호출 추가 가능
    // this.logErrorToService(error, errorInfo);
  }

  private handleRefresh = (): void => {
    // 메인 페이지로 이동
    window.location.href = '/';
  };

  // eslint-disable-next-line react/no-unused-class-component-methods
  private handleRetry = (): void => {
    // 상태 초기화 후 다시 시도
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
  };

  public render(): ReactNode {
    const { hasError, error } = this.state;
    const { children, fallback } = this.props;

    // 에러가 발생했다면 커스텀 폴백 UI를 보여줌
    if (hasError) {
      // 커스텀 폴백이 제공된 경우 그것을 사용
      if (fallback) {
        return fallback;
      }

      // 기본 에러 컴포넌트 사용
      return (
        <ErrorCont
          type={DEFAULT_ERROR_MSG.type}
          title={DEFAULT_ERROR_MSG.title}
          detail={DEFAULT_ERROR_MSG.detail}
          linkText={DEFAULT_ERROR_MSG.linkText}
          logo={DEFAULT_ERROR_MSG.logo}
          onClick={this.handleRefresh}
          className="type-page"
        />
      );
    }

    // 에러가 없다면 자식 컴포넌트를 정상적으로 렌더링
    return children;
  }

  // 비동기 에러를 처리하기 위한 static 메서드
  public static async getDerivedStateFromAsyncError(
    promise: Promise<unknown>
  ): Promise<State> {
    try {
      await promise;
      return {
        hasError: false,
        error: null,
        errorInfo: null,
      };
    } catch (error) {
      return {
        hasError: true,
        error: error instanceof Error ? error : new Error(String(error)),
        errorInfo: null,
      };
    }
  }
}

export default CustomErrorBoundary;
